class BaseModel {
  constructor (options) {
    Object.entries(options || {}).forEach(([key, value]) => {
      this[key] = value
    })
  }
}

export default BaseModel
